import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-yield-max',
    templateUrl: './yield-max.component.html',
    styleUrls: ['./yield-max.component.css'],
    standalone: false
})
export class YieldMaxComponent implements OnInit {

  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  selectedIndex : any = 0;
  propertyId: any;
  extSystemId: any;
  propertyCode: any;
  rate: any;
  updateBulkEdit: boolean = false;

  constructor(private activatedRoute: ActivatedRoute,) {
    if(this.activatedRoute.snapshot.paramMap.get('propertyId'))
    {
      this.propertyId = this.activatedRoute.snapshot.paramMap.get('propertyId');
    }
    if(this.activatedRoute.snapshot.paramMap.get('extSystemId'))
    {
      this.extSystemId = this.activatedRoute.snapshot.paramMap.get('extSystemId');
    }
    if(this.activatedRoute.snapshot.paramMap.get('propertyCode'))
    {
      this.propertyCode = this.activatedRoute.snapshot.paramMap.get('propertyCode');
    }
    if(this.activatedRoute.snapshot.paramMap.get('defaultTabIndx'))
      {
        this.selectedIndex = this.activatedRoute.snapshot.paramMap.get('defaultTabIndx');
        if (this.selectedIndex === '5') {
          // Wait for view initialization to access the tab group and find the "Rate Seasons Summary" tab
          setTimeout(() => {
            this.selectRateSeasonsSummaryTab();
          });
        }
      }
  }

  ngOnInit(): void {
  }

  // Function to dynamically find the index of "Rate Seasons Summary" tab
  selectRateSeasonsSummaryTab() {
    const tabs = this.tabGroup._tabs.toArray(); // Get all the tabs in the tab group
    const rateSeasonsSummaryTab = tabs.find(tab => tab.textLabel === 'Rate Seasons Summary');
    
    if (rateSeasonsSummaryTab) {
      this.selectedIndex = tabs.indexOf(rateSeasonsSummaryTab); // Set the index dynamically
    }
  }

  //Redirect to bulk edit component with selected rate from tape chart
  onRedirectBulkUpdate(rate: any)
  {
    this.rate = rate;
    this.updateBulkEdit = !this.updateBulkEdit; // Just to call on change life cycle of bulk edit
    this.selectedIndex = 6; // index of bulk edit component
  }

  onIndexChange(event)
  {
    this.selectedIndex = event;
  }
}
